import {
  GET_COMMONGROUND,
  POST_COMMONGROUND,
  PROMISE_FULFILLED,
  PROMISE_REJECTED,
  PROMISE_PENDING
} from '../constants'

import parseError from '../utils/error';

const getTypeError = err => {
  // console.log('ERROR14', err.error.status_code);
  switch(err.status_code){
    case 404 : return "NOT_FOUND_ERR";
    case 500 : {
      if(err.message == 'User has already entered this raffle')
        return "ALREADY_SUBMIT_ERR";
    };
    default: return "UNKNOWN_ERR"
  }
}

const initialState = {
  commonground: {
    data: {},
    message: '',
    isFetch: false,
    error: null,
    status_code: 0
  },
  submitCommonGround: {
    data: null,
    isSubmit: false,
    message: '',
    status_code: 0,
    error: null
  }
}

const reducer = (state = initialState, action) => {
  switch(action.type) {
    //get common ground
    case `${GET_COMMONGROUND}${PROMISE_PENDING}`:
      return {...state, commonground: {...state.commonground, isFetch:true}}
    case `${GET_COMMONGROUND}${PROMISE_FULFILLED}`: {
      const { data, status_code, message } = action.payload;
      return{...state, commonground: {...state.commonground, data, status_code, message, isFetch:false, error:null}}
    }
    case `${GET_COMMONGROUND}${PROMISE_REJECTED}`: {
      const { error } = parseError(action.payload)
      return {...state, commonground: {...state.commonground, isFetch: false, error:{...error, type: getTypeError(error)}, status_code: error.status_code}}
    }

    //submit common ground
    case `${POST_COMMONGROUND}${PROMISE_PENDING}`:
      return {...state, submitCommonGround: {...state.submitCommonGround, isSubmit: true}}
    case `${POST_COMMONGROUND}${PROMISE_FULFILLED}`: {
      const { status_code, message, data } = action.payload
      return {...state, submitCommonGround: {...state.submitCommonGround, data, status_code, message, isSubmit:false, error:null}}
    }
    case `${POST_COMMONGROUND}${PROMISE_REJECTED}`: {
      const { error } = parseError(action.payload)
      return {...state, submitCommonGround: {...state.submitCommonGround, error:{...error, type: getTypeError(error)}, isSubmit: false, status_code: error.status_code}}
    }

    default: return state;
  }
}

export default reducer;